import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { setLoading } from "../../../redux/ducks/Loading";
import { useDispatch } from "react-redux";
import { List } from "antd";
import { paginationDefaults } from "../../../utils/properties";
import { EditOutlined } from "@ant-design/icons";
import { showError } from "../../../utils/utilities";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TimesheetPortal from "../../../services/api/TimesheetPortal";

const TimesheetUserList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
      currentPageProjectEstimate: paginationDefaults.page,
      totalCurrentProjectEstimate: paginationDefaults.totalItems,
    },
    list: [],
  });
  useEffect(() => {
    dataList();
  }, []);

  const dataList = async (page = state.pagination.currentPage) => {
    dispatch(setLoading(true));
    const data = await TimesheetPortal.listUser(`page=${page - 1}&size=${state.pagination.size}&sort=surname;asc`);
    if (!data.error) {
      data.data.forEach((item, i) => {
        item.key = i; // This is necessary to remove warning in console for unique key row
      });
      setState((prevState) => ({
        ...prevState,
        list: data.data,
        pagination: {
          currentPage: data.currentPage ? data.currentPage + 1 : paginationDefaults.page,
          size: get(data, "pageSize", paginationDefaults.size),
          totalItems: get(data, "totalItems", paginationDefaults.totalItems),
        },
      }));
    } else {
      showError(get(data, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  return (
    <>
      <List
        header={<strong>{t("timesheet.users")}</strong>}
        bordered
        dataSource={state.list}
        pagination={{
          size: "small",
          showSizeChanger: false,
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(page);
          },
        }}
        renderItem={(item) => (
          <List.Item
            actions={[
              <div
                className="list-actions"
                key={item.id}
                onClick={() => navigate(`${item.cid}`, { state: { userName: item.name, userSurname: item.surname } })}
              >
                <EditOutlined className="icon-medium" />
              </div>,
            ]}
          >
            <List.Item.Meta title={<div>{`${item.surname} ${item.name}`}</div>} />
          </List.Item>
        )}
      />
    </>
  );
};

export default TimesheetUserList;
